export enum Size {
  full = 'full',
  max = 'max',
  min = 'min',
  _3xs = '3xs',
  _2xs = '2xs',
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  _2xl = '2xl',
  _3xl = '3xl',
  _4xl = '4xl',
  _5xl = '5xl',
  _6xl = '6xl',
  _7xl = '7xl',
  _8xl = '8xl',
}

export enum Radii {
  none = 'none',
  sm = 'sm',
  base = 'base',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  _2xl = '2xl',
  _3xl = '3xl',
  full = 'full',
}

export enum ZIndex {
  hide = 'hide',
  auto = 'auto',
  base = 'base',
  docked = 'docked',
  dropdown = 'dropdown',
  sticky = 'sticky',
  banner = 'banner',
  overlay = 'overlay',
  modal = 'modal',
  popover = 'popover',
  skipLink = 'skipLink',
  toast = 'toast',
  tooltip = 'tooltip',
}
